import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/mikawaya21/01/thumbnail.jpg'

const paperInfo = {
    paperName: 'commmune導入事例_MIKAWAYA21株式会社様',
    thumbnail: thumbnail,
    feature1: 'フランチャイズ加盟店同士の情報共有の効果',
    feature2: '双方向コミュニケーションのメリット',
    feature3: 'コミュニティの活性度が高い理由',
    description:
        'シニアのあらゆる困りごとをサポートするサービス「まごころサポート」を全国でフランチャイズ展開しているMIKAWAYA21株式会社の事例です。この資料を読むことで、フランチャイズ加盟店間で接点を持つ効果の理解が深まります。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-07-15/hpwy3',
    type: 'pardot'
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
